import {FlexBox, useBreakpoint} from '@brg/ui';
import {FC, useMemo, ReactNode} from 'react';
import { SlideNavigation } from 'shared/components/slideNavigation';
import {checkIsVisibleSorting} from "../../../helpers/designer/checkIsVisibleSorting";
import { LayoutConst } from 'core';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { getPathContext } from 'core/helpers/getPathContext';
import { AppTester } from 'supporting';
import { DesignerTab } from 'shared/constants/designerTab';

export const ADDITIONAL_TABS_SIGN = 'working_materials';

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

export const DesignerSliderItem: FC<{
    items?: Record<string, ReactNode | string | LinksItems>;
    additionalItems?: Record<string, string>;
    onChange?: (indexKey: string, additionalKey?: string ) => void;
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    overflowX?: boolean;
    isMe?: boolean;
    oneLineSorting?: boolean;
    addTab?: string,
}> = ({
  onChange,
  items,
  additionalItems,
  activeIndexKey,
  isLoading,
  whiteTheme,
  overflowX,
  isMe,
  oneLineSorting,
  addTab
}) => {

    const is940 = useBreakpoint(LayoutConst.screen.md);
    const isProfile = !!useRouteMatch(LinkTo.designer);
    const {application} = getPathContext();
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo make less complicated
    const meTabs = useMemo(() => (isMe ? {
        ...(items?.['competitions'] ? { competitions: items?.['competitions'] } : {}),
        ...(items?.['bookmarks'] ? { bookmarks: items?.['bookmarks'] } : {}),
        ...(items?.['drafts'] ? { drafts: items?.['drafts'] } : {}),
        ...(items?.['draft_books'] ? { draft_books: items?.['draft_books'] } : {}),
        ...(items?.['banned_projects'] ? { banned_projects: items?.['banned_projects'] } : {}),
        ...(items?.['private'] ? { private: items?.['private'] } : {}),
        ...(items?.['draft_presentation'] ? { draft_presentation: items?.['draft_presentation'] } : {}),
        ...(items?.['lms'] ? { lms: items?.['lms'] } : {}),
    } : {}), [items, isMe])

    const tabs = useMemo(() => {
        let list = {};
        for (let key in items) {
            if (!['competitions', 'bookmarks', 'drafts', 'draft_books', 'rejected', 'banned_projects', 'private', 'draft_presentation', 'lms']?.includes(key)) {
                //@ts-ignore
                list[key] = items[key]
            }
        }
        if (list && application.includes('ageytomesh')) {
            return Object.entries(list).filter((item: any) => {
                console.log('entry item', item)
                return !['students', 'organizations', 'jury'].includes(item[0])
            }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return list
    }, [items])


    const addTabsSign = useMemo(
        () => (activeIndexKey === ADDITIONAL_TABS_SIGN || activeIndexKey === DesignerTab.subscribe)
    , [activeIndexKey])

    const additionalTabs = useMemo(() => {
        if (additionalItems && application.includes('ageytomesh')) {
        return Object.entries(additionalItems).filter((item: any) => {
            return !['students', 'organizations', 'jury'].includes(item[0])
        }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return additionalItems
    }, [additionalItems, application])

    const tabsLenght = useMemo(() => (Object.keys(tabs)?.length), [tabs]);
 
    const hasTabs = useMemo(() => !!Object.keys(meTabs)?.length, [meTabs]);
    //@ts-ignore
    const hasAddTabs = useMemo(() => tabs && !!Object.keys(tabs)?.length, [tabs]);
    const isVisibleSorting = useMemo(() => checkIsVisibleSorting(activeIndexKey || ""), [activeIndexKey]);

    const showOneLineSorting = useMemo(() => (oneLineSorting || (isVisibleSorting && Object.keys(tabs)?.length <= 10 && !is940)), [isVisibleSorting, tabsLenght, is940, tabs, oneLineSorting])

    return (
        <FlexBox direction='column' width='100%'>
            {isMe && hasTabs && (
                <FlexBox offsetBottom={16}>
                    <SlideNavigation
                        isDesigner
                        items={meTabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
            )}
            <FlexBox width='100%' direction={showOneLineSorting ? 'row' : 'column'}  justify={showOneLineSorting ? 'space-between' : 'flex-end'} offsetBottom={(isMe && hasTabs && !isProfile) ? 16 : 0}>
                {hasAddTabs && (
                    <SlideNavigation
                        isDesigner
                        items={tabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        dropdownWhiteTheme={whiteTheme}
                    />
                )}

                {/*@ts-ignore*/}
                {!showOneLineSorting && additionalTabs && addTabsSign && isVisibleSorting && <FlexBox direction={'row'} offsetLeft={32} height={(!showOneLineSorting && Object.keys(additionalTabs)?.length) ? 22 : 'auto'} offsetTop={(!showOneLineSorting && Object.keys(additionalTabs)?.length) ? 25 : 0}>
                    {!showOneLineSorting && additionalTabs && addTabsSign && (
                        <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange('', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                    )}
                </FlexBox>}
            </FlexBox>
            {addTabsSign && additionalTabs && showOneLineSorting && (
                <FlexBox offsetTop={25}>
                     <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange('', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                </FlexBox>
            )}
        </FlexBox>
    )
}import {FlexBox, useBreakpoint} from '@brg/ui';
import {FC, useMemo, ReactNode} from 'react';
import { SlideNavigation } from 'shared/components/slideNavigation';
import {checkIsVisibleSorting} from "../../../helpers/designer/checkIsVisibleSorting";
import { LayoutConst } from 'core';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { getPathContext } from 'core/helpers/getPathContext';
import { AppTester } from 'supporting';
import { DesignerTab } from 'shared/constants/designerTab';

export const ADDITIONAL_TABS_SIGN = 'working_materials';

export interface LinksItems {
    action: () => void;
    isLinks: boolean;
    element: ReactNode;
  }

export const DesignerSliderItem: FC<{
    items?: Record<string, ReactNode | string | LinksItems>;
    additionalItems?: Record<string, string>;
    onChange?: (indexKey: string, additionalKey?: string ) => void;
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    overflowX?: boolean;
    isMe?: boolean;
    oneLineSorting?: boolean;
    addTab?: string,
}> = ({
  onChange,
  items,
  additionalItems,
  activeIndexKey,
  isLoading,
  whiteTheme,
  overflowX,
  isMe,
  oneLineSorting,
  addTab
}) => {

    const is940 = useBreakpoint(LayoutConst.screen.md);
    const isProfile = !!useRouteMatch(LinkTo.designer);
    const {application} = getPathContext();
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo make less complicated
    const meTabs = useMemo(() => (isMe ? {
        ...(items?.['competitions'] ? { competitions: items?.['competitions'] } : {}),
        ...(items?.['bookmarks'] ? { bookmarks: items?.['bookmarks'] } : {}),
        ...(items?.['drafts'] ? { drafts: items?.['drafts'] } : {}),
        ...(items?.['draft_books'] ? { draft_books: items?.['draft_books'] } : {}),
        ...(items?.['banned_projects'] ? { banned_projects: items?.['banned_projects'] } : {}),
        ...(items?.['private'] ? { private: items?.['private'] } : {}),
        ...(items?.['draft_presentation'] ? { draft_presentation: items?.['draft_presentation'] } : {}),
        ...(items?.['lms'] ? { lms: items?.['lms'] } : {}),
    } : {}), [items, isMe])

    const tabs = useMemo(() => {
        let list = {};
        for (let key in items) {
            if (!['competitions', 'bookmarks', 'drafts', 'draft_books', 'rejected', 'banned_projects', 'private', 'draft_presentation', 'lms']?.includes(key)) {
                //@ts-ignore
                list[key] = items[key]
            }
        }
        if (list && application.includes('ageytomesh')) {
            return Object.entries(list).filter((item: any) => {
                console.log('entry item', item)
                return !['students', 'organizations', 'jury'].includes(item[0])
            }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return list
    }, [items])


    const addTabsSign = useMemo(
        () => (activeIndexKey === ADDITIONAL_TABS_SIGN || activeIndexKey === DesignerTab.subscribe)
    , [activeIndexKey])

    const additionalTabs = useMemo(() => {
        if (additionalItems && application.includes('ageytomesh')) {
        return Object.entries(additionalItems).filter((item: any) => {
            return !['students', 'organizations', 'jury'].includes(item[0])
        }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return additionalItems
    }, [additionalItems, application])

    const tabsLenght = useMemo(() => (Object.keys(tabs)?.length), [tabs]);
 
    const hasTabs = useMemo(() => !!Object.keys(meTabs)?.length, [meTabs]);
    //@ts-ignore
    const hasAddTabs = useMemo(() => tabs && !!Object.keys(tabs)?.length, [tabs]);
    const isVisibleSorting = useMemo(() => checkIsVisibleSorting(activeIndexKey || ""), [activeIndexKey]);

    const showOneLineSorting = useMemo(() => (oneLineSorting || (isVisibleSorting && Object.keys(tabs)?.length <= 10 && !is940)), [isVisibleSorting, tabsLenght, is940, tabs, oneLineSorting])

    return (
        <FlexBox direction='column' width='100%'>
            {isMe && hasTabs && (
                <FlexBox offsetBottom={16}>
                    <SlideNavigation
                        isDesigner
                        items={meTabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
            )}
            <FlexBox width='100%' direction={showOneLineSorting ? 'row' : 'column'}  justify={showOneLineSorting ? 'space-between' : 'flex-end'} offsetBottom={(isMe && hasTabs && !isProfile) ? 16 : 0}>
                {hasAddTabs && (
                    <SlideNavigation
                        isDesigner
                        items={tabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        dropdownWhiteTheme={whiteTheme}
                    />
                )}

                {/*@ts-ignore*/}
                {!showOneLineSorting && additionalTabs && addTabsSign && isVisibleSorting && <FlexBox direction={'row'} offsetLeft={32} height={(!showOneLineSorting && Object.keys(additionalTabs)?.length) ? 22 : 'auto'} offsetTop={(!showOneLineSorting && Object.keys(additionalTabs)?.length) ? 25 : 0}>
                    {!showOneLineSorting && additionalTabs && addTabsSign && (
                        <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange('', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                    )}
                </FlexBox>}
            </FlexBox>
            {addTabsSign && additionalTabs && showOneLineSorting && (
                <FlexBox offsetTop={25}>
                     <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange('', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                </FlexBox>
            )}
        </FlexBox>
    )
}